import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// Action Text rich-text editor (Trix) — admin training-class descriptions.
// trix must load before @rails/actiontext, which wires Active Storage uploads.
import "trix"
import "@rails/actiontext"

// Brand fonts (bundled via Vite, no external CDN)
import "@fontsource/inter/400.css"
import "@fontsource/inter/500.css"
import "@fontsource/inter/600.css"
import "@fontsource/outfit/700.css"

const application = Application.start()
application.debug = false
window.Stimulus = application

const controllers = import.meta.glob("../controllers/*_controller.js", { eager: true })
for (const path in controllers) {
  const name = path.match(/controllers\/(.+)_controller\.js$/)?.[1]?.replace(/_/g, "-")
  if (name && controllers[path].default) application.register(name, controllers[path].default)
}

export { application }
